import React, { useState, useEffect } from 'react';
import { SketchPicker } from 'react-color';
import TextField from '@mui/material/TextField';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  colorPickerContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  textField: {
    '& .MuiInputBase-root': {
      height: '40px', // Match the height of other input fields
      boxSizing: 'border-box', // Ensure padding is included in the height calculation
      display: 'flex',
      alignItems: 'center',
      padding: '0 14px', // Adjust the padding to match other input fields
    },
    '& .MuiInputBase-input': {
      padding: '10.5px 0', // Adjust the padding to match other input fields
      textAlign: 'left', // Ensure the text is left-aligned
    },
  },
  colorSwatch: {
    width: '24px',
    height: '24px',
    marginLeft: '8px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    cursor: 'pointer', // Add cursor pointer to indicate it's clickable
  },
  popover: {
    position: 'absolute',
    zIndex: '2',
  },
  cover: {
    position: 'fixed',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
  },
});

function ColorPicker({ color, onChangeComplete, id }) {
  const classes = useStyles();
  const [currentColor, setCurrentColor] = useState(color);
  const [showPicker, setShowPicker] = useState(false);

  useEffect(() => {
    setCurrentColor(color);
  }, [color]);

  const handleClick = () => {
    setShowPicker(!showPicker);
  };

  const handleClose = () => {
    setShowPicker(false);
  };

  const handleChangeComplete = (color) => {
    setCurrentColor(color.hex);
    if (onChangeComplete) {
      onChangeComplete(color.hex);
    }
  };

  return (
    <div className={classes.colorPickerContainer}>
      <TextField
        id={id}
        value={currentColor}
        onClick={handleClick}
        readOnly
        className={classes.textField}
        InputProps={{
          readOnly: true,
        }}
      />
      <div
        className={classes.colorSwatch}
        style={{ backgroundColor: currentColor }}
        onClick={handleClick}
      />
      {showPicker && (
        <div className={classes.popover}>
          <div className={classes.cover} onClick={handleClose} />
          <SketchPicker color={currentColor} onChangeComplete={handleChangeComplete} />
        </div>
      )}
    </div>
  );
}

export default ColorPicker;
